<template>
  <div>
    <div class="flashJump">
      <p class="icon-portal-up1 mb16" @click="triggerFlash(undefined)">文档电梯</p>
      <ul>
        <li v-for="(item, index) in elements" :key="index" @click="triggerFlash(item)">
          <span class="icon-portal-down2"></span>{{ item }}
        </li>
      </ul>
    </div>
    <div class="right-content">
      <div ref="slider_and_input" class="slider_and_input">
        <h3 class="mb16">一、&lt;slider-and-input /&gt;</h3>
        <div class="example">
          <div :class="'example_' + type">
            <slider-and-input
              inputWidth="small"
              inputHeight="small"
              :value.sync="rotate"
              :title="'标题'"
              :themeKey="type"
              titlePosition="singleLine"
              :sliderMax="sliderMax"
              suffix="度"
            />
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;slider-and-input</p>
            <p>&nbsp;&nbsp;inputWidth="<span class="code_props">small</span>"</p>
            <p>&nbsp;&nbsp;inputHeight="<span class="code_props">small</span>"</p>
            <p>&nbsp;&nbsp;:value.sync="<span class="code_props">rotate</span>"</p>
            <p>&nbsp;&nbsp;:title="<span class="code_props">标题</span>"</p>
            <p>
              &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
              >"
            </p>
            <p>&nbsp;&nbsp;titlePosition="<span class="code_props">singleLine</span>"</p>
            <p>&nbsp;&nbsp;:sliderMax="<span class="code_props">sliderMax</span>"</p>
            <p>&nbsp;&nbsp;suffix="<span class="code_props">度</span>"</p>
            <p>/&gt;</p>
          </div>
        </div>
        <div class="example">
          <div :class="'example_' + type">
            <slider-and-input
              :value.sync="rotate"
              :title="'标题'"
              :themeKey="type"
              :sliderMax="sliderMax"
              suffix="度"
            />
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;slider-and-input</p>
            <p>&nbsp;&nbsp;:value.sync="<span class="code_props">rotate</span>"</p>
            <p>&nbsp;&nbsp;:title="<span class="code_props">标题</span>"</p>
            <p>
              &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
              >"
            </p>
            <p>&nbsp;&nbsp;:sliderMax="<span class="code_props">sliderMax</span>"</p>
            <p>&nbsp;&nbsp;suffix="<span class="code_props">度</span>"</p>
            <p>/&gt;</p>
          </div>
        </div>
        <div class="example">
          <div :class="'example_' + type">
            <slider-and-input
              :value.sync="rotate"
              :title="image"
              :imageTitle="true"
              :themeKey="type"
              :sliderMax="sliderMax"
              suffix="度"
            />
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;slider-and-input</p>
            <p>&nbsp;&nbsp;:value.sync="<span class="code_props">rotate</span>"</p>
            <p>&nbsp;&nbsp;:title="<span class="code_props">image</span>"</p>
            <p>&nbsp;&nbsp;:imageTitle="<span class="code_props">true</span>"</p>
            <p>
              &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
              >"
            </p>
            <p>&nbsp;&nbsp;titlePosition="<span class="code_props">singleLine</span>"</p>
            <p>&nbsp;&nbsp;:sliderMax="<span class="code_props">sliderMax</span>"</p>
            <p>&nbsp;&nbsp;suffix="<span class="code_props">度</span>"</p>
            <p>/&gt;</p>
          </div>
        </div>
        <div class="mt16">
          <sliderAndInputDoc />
        </div>
      </div>
      <div ref="double_input" class="double_input">
        <h3 class="mb16">二、&lt;double_input /&gt;</h3>
        <div class="example">
          <div :class="'example_' + type">
            <double-input
              title="文字"
              placeHolderText="必填"
              :value1.sync="doubleInputValue1"
              :value2.sync="doubleInputValue2"
              :themeKey="type"
              inputSuffixs="rem"
            />
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;double-input</p>
            <p>&nbsp;&nbsp;title="<span class="code_props">文字</span>"</p>
            <p>&nbsp;&nbsp;placeHolderText="<span class="code_props">必填</span>"</p>
            <p>&nbsp;&nbsp;:value1.sync="<span class="code_props">doubleInputValue1</span>"</p>
            <p>&nbsp;&nbsp;:value2.sync="<span class="code_props">doubleInputValue2</span>"</p>
            <p>&nbsp;&nbsp;:title="<span class="code_props">标题</span>"</p>
            <p>
              &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
              >"
            </p>
            <p>&nbsp;&nbsp;:inputSuffixs="<span class="code_props">rem</span>"</p>
            <p>/&gt;</p>
          </div>
        </div>
        <div class="example">
          <div :class="'example_' + type">
            <double-input
              placeHolderText="必填"
              :value1.sync="doubleInputValue1"
              :value2.sync="doubleInputValue2"
              :themeKey="type"
              :inputSuffixs="['px', '%']"
            />
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;double-input</p>
            <p>&nbsp;&nbsp;title="<span class="code_props">双输入</span>"</p>
            <p>&nbsp;&nbsp;placeHolderText="<span class="code_props">必填</span>"</p>
            <p>&nbsp;&nbsp;:value1.sync="<span class="code_props">doubleInputValue1</span>"</p>
            <p>&nbsp;&nbsp;:value2.sync="<span class="code_props">doubleInputValue2</span>"</p>
            <p>&nbsp;&nbsp;:title="<span class="code_props">标题</span>"</p>
            <p>
              &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
              >"
            </p>
            <p>&nbsp;&nbsp;:inputSuffixs="<span class="code_props">['px', '%']</span>"</p>
            <p>/&gt;</p>
          </div>
        </div>
        <div class="mt16">
          <doubleInputDoc />
        </div>
      </div>
      <div ref="text_setting" class="text_setting">
        <h3 class="mb16">三、&lt;text-setting /&gt;</h3>
        <div class="example">
          <div :class="'example_' + type">
            <text-setting
              :fontColor.sync="fontColor"
              :fontFamily.sync="fontFamily"
              :fontSize.sync="fontSize"
              :fontWeight.sync="fontWeight"
              :themeKey="type"
            />
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;text-setting</p>
            <p>&nbsp;&nbsp;:fontColor.sync="<span class="code_props">fontColor</span>"</p>
            <p>&nbsp;&nbsp;:fontFamily.sync="<span class="code_props">fontFamily</span>"</p>
            <p>&nbsp;&nbsp;:fontSize.sync="<span class="code_props">fontSize</span>"</p>
            <p>&nbsp;&nbsp;:fontWeight.sync="<span class="code_props">fontWeight</span>"</p>
            <p>
              &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
              >"
            </p>
            <p>/&gt;</p>
          </div>
        </div>
        <div class="mt16">
          <textSettingDoc />
        </div>
      </div>
      <div ref="text-setting-complex" class="text-setting-complex">
        <h3 class="mb16">四、&lt;text-setting-complex /&gt;</h3>
        <div class="example">
          <div :class="'example_' + type">
            <text-setting-complex
              :themeKey="type"
              :fontFamily.sync="fontFamily"
              :fontSize.sync="fontSize"
              :fontWeight.sync="fontWeight"
              :fontStyle.sync="fontStyle"
              :textDecoration.sync="textDecoration"
              :lineHeight.sync="lineHeight"
              :letterSpacing.sync="letterSpacing"
              :writingMode.sync="writingMode"
              :textAlign.sync="textAlign"
            />
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;text-setting-complex</p>
            <p>&nbsp;&nbsp;:fontFamily.sync="<span class="code_props">fontFamily</span>"</p>
            <p>&nbsp;&nbsp;:fontSize.sync="<span class="code_props">fontSize</span>"</p>
            <p>&nbsp;&nbsp;:fontWeight.sync="<span class="code_props">fontWeight</span>"</p>
            <p>&nbsp;&nbsp;:fontStyle.sync="<span class="code_props">fontStyle</span>"</p>
            <p>&nbsp;&nbsp;:textDecoration.sync="<span class="code_props">textDecoration</span>"</p>
            <p>&nbsp;&nbsp;:lineHeight.sync="<span class="code_props">lineHeight</span>"</p>
            <p>&nbsp;&nbsp;:letterSpacing.sync="<span class="code_props">letterSpacing</span>"</p>
            <p>&nbsp;&nbsp;:writingMode.sync="<span class="code_props">writingMode</span>"</p>
            <p>&nbsp;&nbsp;:textAlign.sync="<span class="code_props">textAlign</span>"</p>
            <p>
              &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
              >"
            </p>
            <p>/&gt;</p>
          </div>
        </div>
        <div class="mt16">
          <textSettingComplexDoc />
        </div>
      </div>
      <div ref="color_picker" class="color_picker">
        <h3 class="mb16">五、&lt;color-picker /&gt;</h3>
        <div class="example">
          <div :class="'example_' + type">
            <color-picker :color.sync="color" title="颜色选择器" :themeKey="type" />
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;color-picker</p>
            <p>&nbsp;&nbsp;:color.sync="<span class="code_props">color</span>"</p>
            <p>
              &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
              >"
            </p>
            <p>/&gt;</p>
          </div>
        </div>
        <div class="mt16">
          <colorPickerDoc />
        </div>
      </div>
      <div ref="img-upload" class="img-upload">
        <h3 class="mb16">六、&lt;img-upload /&gt;</h3>
        <div class="example">
          <div :class="'example_' + type">
            <img-upload :imgSrc.sync="imgSrc" :defaultImg="defaultBgImage" :themeKey="type"></img-upload>
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;img-upload</p>
            <p>&nbsp;&nbsp;:imgSrc.sync="<span class="code_props">imgSrc</span>"</p>
            <p>&nbsp;&nbsp;:defaultBgImage.sync="<span class="code_props">defaultBgImage</span>"</p>
            <p>
              &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
              >"
            </p>
            <p>/&gt;</p>
          </div>
        </div>
        <div class="mt16">
          <imgUploadDoc />
        </div>
      </div>
      <div ref="img-icon-upload" class="img-icon-upload">
        <h3 class="mb16">七、&lt;img-icon-upload /&gt;</h3>
        <div class="example">
          <div :class="'example_' + type">
            <img-icon-upload :imgSrc.sync="iconSrc" :iconType.sync="iconType" :iconColor.sync="iconColor" />
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;img-icon-upload</p>
            <p>&nbsp;&nbsp;:iconSrc.sync="<span class="code_props">iconSrc</span>"</p>
            <p>&nbsp;&nbsp;:defaultBgImage.sync="<span class="code_props">defaultBgImage</span>"</p>
            <p>&nbsp;&nbsp;:iconType.sync="<span class="code_props">iconType</span>"</p>
            <p>&nbsp;&nbsp;:iconColor.sync="<span class="code_props">iconColor</span>"</p>
            <p>
              &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
              >"
            </p>
            <p>/&gt;</p>
          </div>
        </div>
        <div class="mt16">
          <imgUploadDoc />
        </div>
      </div>
      <div ref="img-crop" class="img-crop">
        <h3 class="mb16">八、&lt;img-crop /&gt;</h3>
        <div class="example">
          <div :class="'example_' + type">
            <img-crop
              :clipSize.sync="clipSize"
              :repeatType.sync="repeatType"
              :alignType.sync="alignType"
              :themeKey="type"
            >
            </img-crop>
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;img-crop</p>
            <p>&nbsp;&nbsp;:clipSize.sync="<span class="code_props">clipSize</span>"</p>
            <p>&nbsp;&nbsp;:repeatType.sync="<span class="code_props">repeatType</span>"</p>
            <p>&nbsp;&nbsp;:alignType.sync="<span class="code_props">alignType</span>"</p>
            <p>
              &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
              >"
            </p>
            <p>/&gt;</p>
          </div>
        </div>
        <div class="mt16">
          <imgCropDoc />
        </div>
      </div>
      <div ref="line_setting" class="line_setting">
        <h3 class="mb16">九、&lt;line-setting /&gt;</h3>
        <div class="example">
          <div :class="'example_' + type">
            <line-setting
              title="边框"
              :lineName.sync="lineName"
              :lineWidth.sync="lineWidth"
              :lineColor.sync="lineColor"
              :themeKey="type"
            />
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;line-setting</p>
            <p>&nbsp;&nbsp;title="<span class="code_props">边框</span>"</p>
            <p>&nbsp;&nbsp;:lineName.sync="<span class="code_props">lineName</span>"</p>
            <p>&nbsp;&nbsp;:lineWidth.sync="<span class="code_props">lineWidth</span>"</p>
            <p>&nbsp;&nbsp;:lineColor.sync="<span class="code_props">lineColor</span>"</p>
            <p>
              &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
              >"
            </p>
            <p>/&gt;</p>
          </div>
        </div>
        <div class="example">
          <div :class="'example_' + type">
            <line-setting title="边框" :lineName.sync="lineName" :lineWidth.sync="lineWidth" :themeKey="type" />
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;line-setting</p>
            <p>&nbsp;&nbsp;title="<span class="code_props">边框</span>"</p>
            <p>&nbsp;&nbsp;:lineName.sync="<span class="code_props">lineName</span>"</p>
            <p>&nbsp;&nbsp;:lineWidth.sync="<span class="code_props">lineWidth</span>"</p>
            <p>
              &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
              >"
            </p>
            <p>/&gt;</p>
          </div>
        </div>
        <div class="mt16">
          <lineSettingDoc />
        </div>
      </div>
      <div ref="cx-check-box" class="cx-check-box">
        <h3 class="mb16">十、&lt;cx-check-box/&gt;</h3>
        <div class="example">
          <div :class="'example_' + type">
            <cx-check-box :value.sync="checkBoxVal" :themeKey="type">开关</cx-check-box>
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;cx-check-box</p>
            <p>&nbsp;&nbsp;:value.sync="<span class="code_props">booleanValue</span>"</p>
            <p>
              &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
              >"
            </p>
            <p>/&gt;</p>
          </div>
        </div>

        <div class="mt16">
          <cxCheckBoxDoc />
        </div>
      </div>
      <div ref="cx-select" class="cx-select">
        <h3 class="mb16">十一、&lt;cx-select/&gt;</h3>
        <div class="example">
          <div :class="'example_' + type">
            <cx-select title="下拉框" :selectOptions="selectOption" :value.sync="selectData" :themeKey="type" />
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;cx-select</p>
            <p>&nbsp;&nbsp;:value.sync="<span class="code_props">selectData</span>"</p>
            <p>&nbsp;&nbsp;:selectOptions="<span class="code_props">selectOption</span>"</p>
            <p>&nbsp;&nbsp;title="<span class="code_props">下拉框</span>"</p>
            <p>
              &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
              >"
            </p>
            <p>/&gt;</p>
          </div>
        </div>

        <div class="mt16">
          <cxSelectDoc />
        </div>
      </div>
      <div ref="box-shadow" class="box-shadow">
        <h3 class="mb16">十二、&lt;box-shadow/&gt;</h3>
        <div class="example">
          <p class="fs14 mb8">因逻辑相对较复杂，所以未同步逻辑，具体使用可参考图片的阴影</p>
          <div :class="'example_' + type">
            <box-shadow
              style="width: 200px"
              :boxShadowH.sync="boxShadowH"
              :boxShadowV.sync="boxShadowV"
              :boxShadowBlur.sync="boxShadowBlur"
              :boxShadowSpread.sync="boxShadowSpread"
              :boxShadowColor.sync="boxShadowColor"
              :isOnlyScan="isOnlyScan"
            />
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;box-shadow</p>
            <p>&nbsp;&nbsp;:boxShadowH.sync="<span class="code_props">boxShadowH</span>"</p>
            <p>&nbsp;&nbsp;:boxShadowV.sync="<span class="code_props">boxShadowV</span>"</p>
            <p>&nbsp;&nbsp;:boxShadowBlur.sync="<span class="code_props">boxShadowBlur</span>"</p>
            <p>&nbsp;&nbsp;:boxShadowSpread.sync="<span class="code_props">boxShadowSpread</span>"</p>
            <p>&nbsp;&nbsp;:boxShadowColor.sync="<span class="code_props">boxShadowColor</span>"</p>
            <p>/&gt;</p>
          </div>
        </div>

        <div class="mt16">
          <boxShadowDoc />
        </div>
      </div>
      <div ref="cx-border" class="cx-border">
        <h3 class="mb16">十三、&lt;cx-border/&gt;</h3>
        <div class="example">
          <div :class="'example_' + type">
            <cx-border
              :borderWidth.sync="borderWidth"
              :borderStyle.sync="borderStyle"
              :borderColor.sync="borderColor"
              :borderIsThemeColor.sync="borderIsThemeColor"
            />
          </div>
          <h4 class="mt8">code:</h4>
          <div class="code_preview code_html">
            <p>&lt;cx-border</p>
            <p>&nbsp;&nbsp;:borderWidth.sync="<span class="code_props">borderWidth</span>"</p>
            <p>&nbsp;&nbsp;:borderStyle.sync="<span class="code_props">borderStyle</span>"</p>
            <p>&nbsp;&nbsp;:borderColor.sync="<span class="code_props">borderColor</span>"</p>
            <p>&nbsp;&nbsp;:borderIsThemeColor.sync="<span class="code_props">borderIsThemeColor</span>"</p>
            <p>/&gt;</p>
          </div>
        </div>

        <div class="mt16">
          <cxBorderDoc />
        </div>
      </div>
      <div ref="cx-bgColor" class="cx-bgColor">
        <h3 class="mb16">十四、&lt;cx-bgColor/&gt;</h3>
        <div :class="'example_bg_' + type">
          <cx-bgColor :data.sync="bgColor" :themeKey="type" />
        </div>
        <h4 class="mt8">code:</h4>
        <div class="code_preview code_html">
          <p>&lt;cx-bgColor</p>
          <p>&nbsp;&nbsp;:data.sync="<span class="code_props">gradient</span>"</p>
          <p>
            &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
            >"
          </p>
          <p>/&gt;</p>
        </div>
        <div class="mt16">
          <cxBgColorDoc />
        </div>
      </div>
      <div ref="chart-color-setting" class="chart-color-setting">
        <h3 class="mb16">十五、&lt;chart-color-setting/&gt;</h3>
        <div :class="'example_bg_' + type">
          <chart-color-setting title="波纹颜色" :color.sync="roundColor" />
        </div>
        <h4 class="mt8">code:</h4>
        <div class="code_preview code_html">
          <p>&lt;chart-color-setting</p>
          <p>&nbsp;&nbsp;:color.sync="<span class="code_props">color</span>"</p>
          <p>&nbsp;&nbsp;title="<span class="code_props">渐变颜色</span>"</p>
          <p>
            &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
            >"
          </p>
          <p>/&gt;</p>
        </div>
        <div class="mt16">
          <chartColorSettingDoc />
        </div>
      </div>
      <div ref="link-set" class="link-set">
        <h3 class="mb16">十六、&lt;link-set/&gt;</h3>
        <div :class="'example_bg_' + type">
          <link-set
            :linkAddress.sync="linkAddress"
            :internalLinkName.sync="internalLinkName"
            :linkUrl.sync="linkUrl"
            :accessRulers.sync="accessRulers"
            :openBlankPage.sync="openBlankPage"
          />
        </div>
        <h4 class="mt8">code:</h4>
        <div class="code_preview code_html">
          <p>&lt;link-set</p>
          <p>&nbsp;&nbsp;:linkAddress.sync="<span class="code_props">linkAddress</span>"</p>
          <p>&nbsp;&nbsp;internalLinkName.sync="<span class="code_props">internalLinkName</span>"</p>
          <p>&nbsp;&nbsp;linkUrl.sync="<span class="code_props">linkUrl</span>"</p>
          <p>&nbsp;&nbsp;accessRulers.sync="<span class="code_props">accessRulers</span>"</p>
          <p>&nbsp;&nbsp;openBlankPage.sync="<span class="code_props">openBlankPage</span>"</p>
          <p>
            &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
            >"
          </p>
          <p>/&gt;</p>
        </div>
        <div class="mt16">
          <linkSetDoc />
        </div>
      </div>
      <div ref="border-radius" class="cx-border-radius">
        <h3 class="mb16">十七、&lt;border-radius/&gt;</h3>
        <div :class="'example_bg_' + type">
          <border-radius
            :borderTypeFlag.sync="borderTypeFlag"
            :borderRadius.sync="borderRadius"
            :borderTopLeftRadius.sync="borderTopLeftRadius"
            :borderTopRightRadius.sync="borderTopRightRadius"
            :borderBottomRightRadius.sync="borderBottomRightRadius"
            :borderBottomLeftRadius.sync="borderBottomLeftRadius"
          />
        </div>
        <h4 class="mt8">code:</h4>
        <div class="code_preview code_html">
          <p>&lt;border-radius</p>
          <p>&nbsp;&nbsp;:borderTypeFlag.sync="<span class="code_props">borderTypeFlag</span>"</p>
          <p>&nbsp;&nbsp;borderRadius.sync="<span class="code_props">borderRadius</span>"</p>
          <p>&nbsp;&nbsp;borderTopLeftRadius.sync="<span class="code_props">borderTopLeftRadius</span>"</p>
          <p>&nbsp;&nbsp;borderTopRightRadius.sync="<span class="code_props">borderTopRightRadius</span>"</p>
          <p>&nbsp;&nbsp;borderBottomRightRadius.sync="<span class="code_props">borderBottomRightRadius</span>"</p>
          <p>&nbsp;&nbsp;borderBottomLeftRadius.sync="<span class="code_props">borderBottomLeftRadius</span>"</p>
          <p>
            &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
            >"
          </p>
          <p>/&gt;</p>
        </div>
        <div class="mt16">
          <borderRadiusDoc />
        </div>
      </div>
      <div ref="cx-padding" class="cx-padding">
        <h3 class="mb16">十七、&lt;cx-padding/&gt;</h3>
        <div :class="'example_bg_' + type">
          <cx-padding
            :paddingTypeFlag.sync="paddingTypeFlag"
            :padding.sync="padding"
            :paddingTop.sync="paddingTop"
            :paddingRight.sync="paddingRight"
            :paddingBottom.sync="paddingBottom"
            :paddingLeft.sync="paddingLeft"
          />
        </div>
        <h4 class="mt8">code:</h4>
        <div class="code_preview code_html">
          <p>&lt;cx-padding</p>
          <p>&nbsp;&nbsp;:paddingTypeFlag.sync="<span class="code_props">paddingTypeFlag</span>"</p>
          <p>&nbsp;&nbsp;padding.sync="<span class="code_props">padding</span>"</p>
          <p>&nbsp;&nbsp;paddingTop.sync="<span class="code_props">paddingTop</span>"</p>
          <p>&nbsp;&nbsp;paddingRight.sync="<span class="code_props">paddingRight</span>"</p>
          <p>&nbsp;&nbsp;paddingBottom.sync="<span class="code_props">paddingBottom</span>"</p>
          <p>&nbsp;&nbsp;paddingLeft.sync="<span class="code_props">paddingLeft</span>"</p>
          <p>
            &nbsp;&nbsp;themeKey="<span class="code_props">{{ type }}</span
            >"
          </p>
          <p>/&gt;</p>
        </div>
        <div class="mt16">
          <cxPaddingDoc />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import testImage from "assets/images/echarts/grid-left.png"
import sliderAndInputDoc from "./componentApiDoc/sliderAndInputDoc.vue"
import doubleInputDoc from "./componentApiDoc/doubleInputDoc.vue"
import textSettingComplexDoc from "./componentApiDoc/textSettingComplexDoc.vue"
import textSettingDoc from "./componentApiDoc/textSettingDoc.vue"
import lineSettingDoc from "./componentApiDoc/lineSettingDoc.vue"
import colorPickerDoc from "./componentApiDoc/colorPickerDoc.vue"
import imgUploadDoc from "./componentApiDoc/imgUploadDoc.vue"
import imgIconUploadDoc from "./componentApiDoc/imgUploadDoc.vue"
import imgCropDoc from "./componentApiDoc/imgCropDoc.vue"
import cxCheckBoxDoc from "./componentApiDoc/cxCheckBoxDoc.vue"
import cxSelectDoc from "./componentApiDoc/cxSelectDoc.vue"
import boxShadowDoc from "./componentApiDoc/boxShadowDoc.vue"
import cxBorderDoc from "./componentApiDoc/cxBorderDoc.vue"
import cxBgColorDoc from "./componentApiDoc/cxBgColorDoc.vue"
import chartColorSettingDoc from "./componentApiDoc/chartColorSettingDoc.vue"
import linkSetDoc from "./componentApiDoc/linkSetDoc.vue"
import borderRadiusDoc from "./componentApiDoc/borderRadiusDoc.vue"
import cxPaddingDoc from "./componentApiDoc/cxPaddingDoc.vue"
export default {
  components: {
    cxPaddingDoc,
    borderRadiusDoc,
    linkSetDoc,
    sliderAndInputDoc,
    doubleInputDoc,
    textSettingDoc,
    lineSettingDoc,
    textSettingComplexDoc,
    colorPickerDoc,
    imgUploadDoc,
    imgIconUploadDoc,
    imgCropDoc,
    cxCheckBoxDoc,
    cxSelectDoc,
    boxShadowDoc,
    cxBorderDoc,
    cxBgColorDoc,
    chartColorSettingDoc
  },
  props: {
    type: {
      type: String
    }
  },
  data() {
    return {
      isOnlyScan: true,
      checkBoxVal: true,
      selectData: "",
      roundColor: "#ffffff",
      selectOption: [
        { label: "底部", value: "bottom" },
        { label: "顶部", value: "top" },
        { label: "左侧", value: "left" },
        { label: "右侧", value: "right" }
      ],
      elements: [
        "slider_and_input",
        "double_input",
        "text_setting",
        "text-setting-complex",
        "color_picker",
        "img-upload",
        "img-icon-upload",
        "img-crop",
        "line_setting",
        "cx-check-box",
        "cx-select",
        "cx-box-shadow",
        "cx-border",
        "cx-bgColor",
        "chart-color-setting",
        "link-set",
        "border-radius",
        "cx-padding"
      ],
      image: testImage,
      rotate: 10,
      sliderMax: 100,
      doubleInputValue1: 10,
      doubleInputValue2: 10,
      fontFamily: "sans-serif",
      fontSize: 12,
      fontWeight: "200",
      fontColor: "#ffffff",
      color: "#ffffff",
      fontStyle: "normal",
      textDecoration: "none",
      lineHeight: 34,
      letterSpacing: 0,
      writingMode: "horizontal-tb",
      textAlign: "left",
      imgSrc: "",
      iconSrc: "",
      iconType: "img",
      iconColor: "#e9e9e9",
      defaultBgImage: require("../../assets/images/default_image.png"),
      clipSize: "auto auto",
      repeatType: "no-repeat",
      alignType: "center center",
      lineName: "solid",
      lineWidth: 1,
      lineColor: "#ffffff",
      boxShadowH: 0,
      boxShadowV: 0,
      boxShadowBlur: 0,
      boxShadowSpread: 0,
      boxShadowColor: "#000",
      borderWidth: [1, 1, 1, 1],
      borderStyle: "solid",
      borderColor: "#fff",
      borderIsThemeColor: false,
      bgColor: {
        angle: 20,
        stops: [
          ["#0359b5", 0],
          ["#0231b5", 0.5],
          ["#f6ce01", 1]
        ]
      },
      openBlankPage: true,
      linkUrl: "",
      internalLinkName: "",
      accessRulers: [],
      linkAddress: "无",
      borderTypeFlag: 2,
      borderRadius: 0,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      paddingTypeFlag: 1,
      padding: 0,
      paddingTop: 0,
      paddingRight: 0,
      paddingLeft: 0,
      paddingBottom: 0
    }
  },
  methods: {
    triggerFlash(refName) {
      if (refName) {
        window.scrollTo(0, this.$refs[refName].offsetTop)
      } else {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>

<style scoped>
.example_portal {
  border: 1px solid gray;
  padding: 20px;
  width: 292px;
  border-radius: 10px;
}
.example_bigScreen {
  background: #1f2124;
  padding: 20px;
  width: 292px;
  border-radius: 10px;
}
.example_bg_portal {
  border: 1px solid gray;
  padding: 12px;
  width: 300px;
  border-radius: 4px;
}
.example_bg_bigScreen {
  background: #1f2124;
  padding: 12px;
  width: 300px;
  border-radius: 4px;
}
.code_html {
  padding-left: 20px;
  color: #3182bd;
  font-size: 14px;
}
.code_props {
  color: #756bb1;
}
.code_inner {
  color: black;
}
.flashJump .element_point {
  color: var(--themeColor);
  font-size: 30px;
  font-weight: 1000;
}
.flashJump {
  position: fixed;
  left: 0;
  top: 150px;
  width: 200px;
  max-height: 500px;
  overflow: auto;
  padding: 20px;
  box-sizing: border-box;
  z-index: 1;
}
.flashJump ul li:hover {
  cursor: pointer;
}
.icon-portal-up1:hover {
  cursor: pointer;
}
.flashJump ul li {
  line-height: 20px;
  margin-bottom: 8px;
}
.right-content {
  padding-left: 240px;
  box-sizing: border-box;
  height: 100%;
  overflow: auto;
}
</style>
